export const classesCounts = ['1-4', '4-8', '8-12', '12-16', '16-20']

export const suitableTimes = [
  {
    value: 'morning',
    label: 'Morning (06-09)',
    icon: '/assets/icon/morning.svg',
  },
  {
    value: 'late-morning',
    label: 'Late Morning (09-12)',
    icon: '/assets/icon/lateMorning.svg',
  },
  {
    value: 'afternoon',
    label: 'Afternoon (12-15)',
    icon: '/assets/icon/afternoon.svg',
  },
  {
    value: 'late-afternoon',
    label: 'Late Afternoon (15-18) ',
    icon: '/assets/icon/lateAfternoon.svg',
  },
  {
    value: 'evening',
    label: 'Evening (18-21)',
    icon: '/assets/icon/morning.svg',
  },
  {
    value: 'late-evening',
    label: 'Late Evening (21-24)',
    icon: '/assets/icon/lateEvening.svg',
  },
  {
    value: 'night',
    label: 'Night (00-03)',
    icon: '/assets/icon/night.svg',
  },
  {
    value: 'late-night',
    label: 'Late Night (03-06)',
    icon: '/assets/icon/lateNight.svg',
  },
]

export const daysOfWeek = [
  {
    value: 'mon',
    label: 'Mon',
  },
  {
    value: 'tue',
    label: 'Tue',
  },
  {
    value: 'wed',
    label: 'Wed',
  },
  {
    value: 'thu',
    label: 'Thur',
  },
  {
    value: 'fri',
    label: 'Fri',
  },
  {
    value: 'sat',
    label: 'Sat',
  },
  {
    value: 'sun',
    label: 'Sun',
  },
]
